const ITEMS = ["Scan & Shop", "Discover", "Shop Your Way", "The Studio", "My Closet", "The Community"];

function Row({ hidden }) {
    return (
        <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
            {ITEMS.map((t) => (
                <span key={t} className="flex items-center">
                    <span className="whitespace-nowrap px-8 text-xl font-extralight uppercase tracking-[0.22em] text-slate-400 sm:text-2xl">
                        {t}
                    </span>
                    <span className="h-1.5 w-1.5 rounded-full bg-slate-300" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <section className="overflow-hidden border-b border-slate-100 bg-white py-7" aria-label="EDIT features marquee">
            <div className="animate-marquee flex w-max">
                <Row />
                <Row hidden />
            </div>
        </section>
    );
}
